export default "__VITE_ASSET__CngQvDyW__"